import { render, staticRenderFns } from "./epms1020_detail.vue?vue&type=template&id=04d1172c&scoped=true"
import script from "./epms1020_detail.vue?vue&type=script&lang=js"
export * from "./epms1020_detail.vue?vue&type=script&lang=js"
import style0 from "./epms1020_detail.vue?vue&type=style&index=0&id=04d1172c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d1172c",
  null
  
)

export default component.exports